import { render } from "./LoginBlock.vue?vue&type=template&id=8c03d758&scoped=true"
import script from "./LoginBlock.vue?vue&type=script&lang=js"
export * from "./LoginBlock.vue?vue&type=script&lang=js"

import "./LoginBlock.vue?vue&type=style&index=0&id=8c03d758&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c03d758"]])

export default __exports__